/* Baesics — landings: abrir el cart drawer en vez de redirigir a /cart
 *
 * Las landings (turtleneck, boxy mesh) tienen su propio addToCart que termina en
 * window.location.href = '/cart'. Eso saltea el drawer (barra de envío gratis + upsells).
 *
 * Este script escucha el click en fase de captura sobre document, que SIEMPRE corre antes
 * que los listeners atados al botón, y corta la propagación con stopImmediatePropagation.
 * Si algo falla, no hace nada y el handler original sigue funcionando como antes.
 */
(function () {
  'use strict';

  var BUTTONS = '#tn-add, #tn-add-sticky, #bm-add, #bm-add-sticky';
  var SIZES = '.tn-size, .bm-size';

  function selectedVariantId() {
    var on = document.querySelector('.tn-size.on, .bm-size.on');
    if (on && on.getAttribute('data-id')) return on.getAttribute('data-id');
    var all = document.querySelectorAll(SIZES);
    for (var i = 0; i < all.length; i++) {
      if (!all[i].disabled && all[i].getAttribute('data-id')) return all[i].getAttribute('data-id');
    }
    return null;
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  function addAndOpen(btn, variantId) {
    var original = btn.textContent;
    btn.textContent = 'Agregando...';
    btn.disabled = true;

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));

    var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'cart');
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = {
            resource: cart,
            sourceId: 'landing',
            data: { source: 'landing', itemCount: 1, variantId: String(variantId), sections: res.sections || {} }
          };
          document.dispatchEvent(ev);

          btn.disabled = false;
          if (!openDrawer()) {
            window.location.href = '/cart';
            return;
          }
          btn.textContent = 'Agregado';
          setTimeout(function () { btn.textContent = original; }, 1800);
        });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Error — proba de nuevo';
        setTimeout(function () { btn.textContent = original; }, 2500);
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(BUTTONS);
      if (!btn) return;

      var variantId = selectedVariantId();
      if (!variantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      addAndOpen(btn, variantId);
    },
    true
  );
})();
